import React from 'react';
import { Grid } from '@mui/material';
import { formatDate } from '../../../utils/CommonColumnFunction';

const NotificationItem = ({ filteredData }) => {
  return (
    <>
      {filteredData?.map(value => {
        return (
          <Grid
            key={value.notificationId}
            style={{
              border: '1px solid #ECF0E5',
              borderRadius: '8px',
              marginBottom: '8px'
            }}
          >
            <div style={{ padding: '16px 16px 5px' }}>
              <div
                style={{
                  fontSize: 14,
                  color: '#21241E',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
                className='medium5'
              >
                {value.title ? value.title : '-'}
              </div>
              <div style={{ justifyContent: 'space-between', display: 'flex', paddingTop: '5px' }}>
                <div
                  className='medium7'
                  style={{
                    fontSize: 12,
                    color: '#21241E',
                    whiteSpace: 'nowrap',
                    minWidth: '45px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  By {value.createdBy}
                </div>

                <div
                  className='medium7'
                  style={{
                    fontSize: 12,
                    color: '#21241E',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {value?.stampOrders?.stampTotalAmount ? `Rs ${value?.stampOrders?.stampTotalAmount}` : null}
                </div>
              </div>
            </div>
            <div
              style={{
                backgroundColor:
                  value?.approvalType === 'Approved' || value?.approvalType === 'Accepted' ? '#eaf3be' : '#ECF0E5',
                padding: '10px 16px',
                borderRadius: 8
              }}
            >
              <div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <div
                    style={{
                      height: '10px',
                      width: '10px',
                      borderRadius: '50%',
                      backgroundColor:
                        value?.approvalType === 'Approved' || value?.approvalType === 'Accepted' ? '#B7D423' : '#EFAC00'
                    }}
                  />
                  <div
                    className='medium7'
                    style={{
                      fontSize: 12,
                      color:
                        value?.approvalType === 'Approved' || value?.approvalType === 'Accepted' ? '#B7D423' : '#EFAC00'
                    }}
                  >
                    {value.approvalType}
                  </div>
                </div>
                <div style={{ paddingTop: '2px' }}>
                  <p style={{ fontWeight: 400, fontSize: '12px', color: '#0A0909' }}>
                    {value?.approvalType === 'Approved' || value?.approvalType === 'Accepted'
                      ? 'Signed by all the recipients'
                      : `Sent for approval | ${formatDate(value.createdAt)}`}
                  </p>
                </div>
              </div>
            </div>
          </Grid>
        );
      })}
    </>
  );
};

export default NotificationItem;
